__turbopack_context__.v({
  "container": "styles-module-scss-module__n8S9_G__container",
  "question": "styles-module-scss-module__n8S9_G__question",
  "subheader": "styles-module-scss-module__n8S9_G__subheader",
  "tour_btn": "styles-module-scss-module__n8S9_G__tour_btn",
});
